import React from 'react';
import BarcodePage from './BarcodePage';


// Class based wrapper for printable barcode (as required by the 'react-to-print' library).
export class BarcodeWrapper extends React.PureComponent {
    render() {
        return (
            <div>
                <BarcodePage config={this.props.config} record={this.props.record}></BarcodePage>
            </div>
        );
    }
  }

export default BarcodeWrapper;
